/**
 * 合并同一 key 的并发请求（含 React StrictMode 开发态双挂载）。
 * 短时缓存结果，避免 remount 立刻再打一枪。
 */
export function shareAsync<T>(
  cache: Map<string, Promise<T>>,
  key: string,
  factory: () => Promise<T>,
  ttlMs = 1500,
): Promise<T> {
  const existing = cache.get(key);
  if (existing) return existing;

  const pending = factory().finally(() => {
    const release = () => {
      if (cache.get(key) === pending) cache.delete(key);
    };
    if (typeof window !== 'undefined') {
      window.setTimeout(release, ttlMs);
    } else {
      release();
    }
  });
  cache.set(key, pending);
  return pending;
}
